module.exports = __webpack_public_path__ + "static/media/contact_us_student_cropped.077cd8c2.jpeg";